import Vue from 'vue'
import VueRouter from 'vue-router'
import { default as store } from '../store'
import Main from '../components/dashboard/Main'
import Signin from '../components/user/Signin'
import Dashboard from '../components/dashboard/Dashboard'
import Approver from '../components/mobile-user/Approver'
import ApproverDetail from '../components/mobile-user/ApproverDetail'
import ChangeApprover from '../components/mobile-user/ChangeApprover'
import NewApprover from '../components/mobile-user/NewApprover'
import ChangeApproverPassword from '../components/mobile-user/ChangeApproverPassword'
import Workflow from '../components/workflow/Workflow'
import WorkflowDetail from '../components/workflow/WorkflowDetail'
import ChangeWorkflow from '../components/workflow/ChangeWorkflow'
import NewWorkflow from '../components/workflow/NewWorkflow'
import Division from '../components/division/Division'
import DivisionDetail from '../components/division/DivisionDetail'
import NewDivision from '../components/division/NewDivision'
import ChangeDivision from '../components/division/ChangeDivision'
import Department from '../components/department/Department'
import DepartmentDetail from '../components/department/DepartmentDetail'
import NewDepartment from '../components/department/NewDepartment'
import ChangeDepartment from '../components/department/ChangeDepartment'
import Rank from '../components/rank/Rank'
import RankDetail from '../components/rank/RankDetail'
import NewRank from '../components/rank/NewRank'
import ChangeRank from '../components/rank/ChangeRank'
import Plant from '../components/plant/Plant'
import PlantDetail from '../components/plant/PlantDetail'
import NewPlant from '../components/plant/NewPlant'
import ChangePlant from '../components/plant/ChangePlant'
import Profile from '../components/user/Profile'
import ProfileDetail from '../components/user/ProfileDetail'
import ChangePassword from '../components/user/ChangePassword'
import Limit from '../components/approval-limit/Limit'
import LimitDetail from '../components/approval-limit/LimitDetail'
import NewLimit from '../components/approval-limit/NewLimit'
import ChangeLimit from '../components/approval-limit/ChangeLimit'
import Company from '../components/company/Company'
import CompanyDetail from '../components/company/CompanyDetail'
import NewCompany from '../components/company/NewCompany'
import ChangeCompany from '../components/company/ChangeCompany'
import PrReport from '../components/report/PrReport'
import PoReport from '../components/report/PoReport'
import Admin from '../components/admin-user/Admin'
import AdminDetail from '../components/admin-user/AdminDetail'
import NewAdmin from '../components/admin-user/NewAdmin'
import ChangeAdmin from '../components/admin-user/ChangeAdmin'
import ChangeAdminPassword from '../components/admin-user/ChangeAdminPassword'

Vue.use(VueRouter)

const routes = [
  {
    path: '/signin',
    name: 'signIn',
    component: Signin
  },
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '',
    component: Main,
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { requiresAuth: true }
      },
      {
        path: 'approver',
        component: Approver,
        children: [
          {
            path: '',
            name: 'approverDetail',
            component: ApproverDetail,
            meta: { requiresAuth: true }
          },
          {
            path: 'new',
            name: 'newApprover',
            component: NewApprover,
            meta: { requiresAuth: true }
          },
          {
            path: 'change/:id',
            name: 'changeApprover',
            props: true,
            component: ChangeApprover
          },
          {
            path: 'change-approver-password/:id',
            name: 'ChangeApproverPassword',
            params: true,
            component: ChangeApproverPassword,
            meta: { requiresAuth: true }
          }
        ]
      },
      {
        path: 'limit',
        component: Limit,
        children: [
          {
            path: '',
            name: 'limitDetail',
            component: LimitDetail,
            meta: { requiresAuth: true }
          },
          {
            path: 'new',
            name: 'newLimit',
            component: NewLimit,
            meta: { requiresAuth: true }
          },
          {
            path: 'change/:id',
            name: 'changeLimit',
            props: true,
            component: ChangeLimit,
            meta: { requiresAuth: true }
          }
        ]
      },
      {
        path: 'workflow',
        component: Workflow,
        children: [
          {
            path: '',
            name: 'WorkflowDetail',
            component: WorkflowDetail,
            meta: { requiresAuth: true }
          },
          {
            path: 'new',
            name: 'newWorkflow',
            component: NewWorkflow,
            meta: { requiresAuth: true }
          },
          {
            path: 'change/:id',
            name: 'changeWorkflow',
            props: true,
            component: ChangeWorkflow,
            meta: { requiresAuth: true }
          }
        ]
      },
      {
        path: 'company',
        component: Company,
        children: [
          {
            path: '',
            name: 'companyDetail',
            component: CompanyDetail,
            meta: { requiresAuth: true }
          },
          {
            path: 'new',
            name: 'newCompany',
            component: NewCompany,
            meta: { requiresAuth: true }
          },
          {
            path: 'change/:id',
            name: 'changeCompany',
            props: true,
            component: ChangeCompany,
            meta: { requiresAuth: true }
          }
        ]
      },
      {
        path: 'division',
        component: Division,
        children: [
          {
            path: '',
            name: 'divisionDetail',
            component: DivisionDetail,
            meta: { requiresAuth: true }
          },
          {
            path: 'new',
            name: 'newDivision',
            component: NewDivision,
            meta: { requiresAuth: true }
          },
          {
            path: 'change/:id',
            name: 'changeDivision',
            props: true,
            component: ChangeDivision,
            meta: { requiresAuth: true }
          }
        ]
      },
      {
        path: 'department',
        component: Department,
        children: [
          {
            path: '',
            name: 'departmentDetail',
            component: DepartmentDetail,
            meta: { requiresAuth: true }
          },
          {
            path: 'new',
            name: 'newDepartment',
            component: NewDepartment,
            meta: { requiresAuth: true }
          },
          {
            path: 'change/:id',
            name: 'changeDepartment',
            props: true,
            component: ChangeDepartment,
            meta: { requiresAuth: true }
          }
        ]
      },
      {
        path: 'release-code',
        component: Rank,
        children: [
          {
            path: '',
            name: 'releaseCodeDetail',
            component: RankDetail,
            meta: { requiresAuth: true }
          },
          {
            path: 'new',
            name: 'newReleaseCode',
            component: NewRank,
            meta: { requiresAuth: true }
          },
          {
            path: 'change/:id',
            name: 'changeReleaseCode',
            props: true,
            component: ChangeRank,
            meta: { requiresAuth: true }
          }
        ]
      },
      {
        path: 'plant',
        component: Plant,
        children: [
          {
            path: '',
            name: 'plantDetail',
            component: PlantDetail,
            meta: { requiresAuth: true }
          },
          {
            path: 'new',
            name: 'newPlant',
            component: NewPlant,
            meta: { requiresAuth: true }
          },
          {
            path: 'change/:id',
            name: 'changePlant',
            props: true,
            component: ChangePlant,
            meta: { requiresAuth: true }
          }
        ]
      },
      {
        path: 'profile',
        component: Profile,
        children: [
          {
            path: '',
            name: 'profileDetail',
            component: ProfileDetail,
            meta: { requiresAuth: true }
          },
          {
            path: 'changepassword',
            name: 'changePassword',
            component: ChangePassword,
            meta: { requiresAuth: true }
          }
        ]
      },
      {
        path: 'pr-report',
        name: 'pr-report',
        component: PrReport,
        meta: { requiresAuth: true }
      },
      {
        path: 'po-report',
        name: 'po-report',
        component: PoReport,
        meta: { requiresAuth: true }
      },
      {
        path: 'admin',
        component: Admin,
        children: [
          {
            path: '',
            name: 'adminDetail',
            component: AdminDetail,
            meta: { requiresAuth: true }
          },
          {
            path: 'new',
            name: 'newAdmin',
            component: NewAdmin,
            meta: { requiresAuth: true }
          },
          {
            path: 'change/:id',
            name: 'changeAdmin',
            props: true,
            component: ChangeAdmin,
            meta: { requiresAuth: true }
          },
          {
            path: 'changepassword/:id',
            name: 'changeAdminPassword',
            props: true,
            component: ChangeAdminPassword,
            meta: { requiresAuth: true }
          }
        ]
      }
    ]
  }
]
const router = new VueRouter({
  // mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let allowPath = store.getters.getAllowedMenuPath
    const AUTH_TOKEN = localStorage.getItem('accesstoken')
    if (AUTH_TOKEN) {
      if (allowPath.length > 0) {
        let isAllowed = allowPath.some(element => {
          return to.fullPath.startsWith(element)
        })
        if (isAllowed) {
          next()
        } else {
          next({path: '/', replace: true})
        }
      }
    } else {
      next({path: '/signin', query: {redirect: to.fullPath}})
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js